import React, { useEffect, useState } from "react";
import { Button } from "../../ui/Button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../ui/Card";
import { Input } from "../../ui/Input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/Select";
import { Users, UserPlus, Search, Loader2, UserCheck } from "lucide-react";
import axios from "../../axios/AxiosInstance";
import { message } from "antd";
import CreateCandidateModal from "./CreateCandidateModal";
//import { CandidateModal } from "./candidate/CandidateModal";
import PageHeader from "../../ui/PageHeader";
import { CandidateModal } from "./FicheCandidat";


export default function CandidatsPage() {
  const containerStyle = {
    padding: "24px",
    fontFamily: "sans-serif",
    backgroundColor: "white",
    minHeight: "calc(100vh - 64px)", // Assuming a topbar of 64px
  };

  const [candidates, setCandidates] = useState([]);
  const [originalCandidates, setOriginalCandidates] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [isAddCandidate, setIsAddCandidate] = useState(false);
  const [isViewCandidate, setIsViewCandidate] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [searchTimeout, setSearchTimeout] = useState(null); // pour annuler les anciens appels
  const [searchStatus, setSearchStatus] = useState('tous');
  const [searchMode, setSearchMode] = useState("auto"); 
  const [searchText, setSearchText] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");


const search = (word) => {
  if (searchTimeout) {
    clearTimeout(searchTimeout);
  }

  if (word.length === 0) {
  // filtrer par status si nécessaire
  const filtered = searchStatus === "tous"
    ? originalCandidates
    : originalCandidates.filter(c => c.status === searchStatus);
  setCandidates(filtered);
  setLoadingSearch(false);
  return;
}


  setLoadingSearch(true);

  const timeoutId = setTimeout(() => {
    axios
      .get("tempworker-candidate/client/search", {
        params: {
          q: word,
          status: searchStatus,
        },
      })
      .then((res) => {
        setCandidates(res.data);
        setLoadingSearch(false);
      })
      .catch((e) => {
        setLoadingSearch(false);
        console.error(e);
      });
  }, 500);

  setSearchTimeout(timeoutId);
};


  useEffect(() => {
    loadCandidates();
  }, []);

  useEffect(() => {
  // ne rien faire tant que les candidats ne sont pas chargés
  if (!originalCandidates.length) return;

  if (searchTimeout) clearTimeout(searchTimeout);

  const timeoutId = setTimeout(() => {
    search(searchText);
  }, 500);

  setSearchTimeout(timeoutId);
}, [searchText, searchStatus, originalCandidates]);

  
  const viewCandidate = (candidate) => {
    setSelectedCandidate(candidate._id);
    setIsViewCandidate(true);
  };

  const loadCandidates = () => {
    setIsLoading(true);
    axios
      .get("/tempworker-candidate/client")
      .then((res) => {
        setCandidates(res.data);
        setOriginalCandidates(res.data);
        console.log(res.data);
      })
      .catch((e) => {
        console.log(e);
        message.error("Une erreur s'est produite !");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="w-full h-screen p-6 bg-white rounded-lg shadow-sm text-left">
      <PageHeader
      icon={UserCheck}
      title="Gérez votre base de candidats"
      description="Centralisez les profils, suivez les candidatures et identifiez
        rapidement les meilleurs talents pour chaque mission. Votre vivier de
        compétences à portée de clic."
    />
    
      
    <div style={containerStyle}>
      {loadingSearch && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray-500 bg-opacity-50 z-[9999]">
          <Loader2 className="animate-spin h-10 w-10 text-blue-600" />
        </div>
      )}

      {isAddCandidate && (
        <CreateCandidateModal
          open={isAddCandidate}
          candidates={candidates}
          setCandidates={setCandidates}
          onOpenChange={setIsAddCandidate}
        />
      )}
       
      {isViewCandidate && selectedCandidate && (
        <CandidateModal
          isOpen={isViewCandidate}
          onClose={() => setIsViewCandidate(false)}
          candidates={candidates}
          setCandidates={setCandidates}
          candidate={candidates.find(c => c._id === selectedCandidate)}
        />
      )}

      

      <div className="flex justify-end mb-8">
        <Button onClick={() => setIsAddCandidate(true)} size="lg" className="bg-black text-white hover:bg-black">
          <UserPlus size={18} className="mr-2" /> Ajouter un nouveau candidat
        </Button>
      </div>

      {/* Barre d'outils */}
      <div className="mb-8 p-4 bg-white shadow rounded-lg flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-4">
        <div className="relative w-[380px]">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
          <Input
            type="search"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Rechercher un candidat (nom, compétence...)"
            className="pl-10 w-full"
          />
        </div>
        
        <Select onValueChange={(value) => setSearchStatus(value)} value={searchStatus}>
  <SelectTrigger className="w-full sm:w-[180px] bg-white text-gray-400">
    <SelectValue placeholder="Statut" />
  </SelectTrigger>
  <SelectContent className="bg-white">
    <SelectItem value="tous">Tous les statuts</SelectItem>
    <SelectItem value="Disponible">Disponible</SelectItem>
    <SelectItem value="Indisponible">Indisponible</SelectItem>
    <SelectItem value="Bloqué">Bloqué</SelectItem>
    <SelectItem value="Supprimé">Supprimé</SelectItem>
  </SelectContent>
</Select>

      </div>

      {/* Chargement */}
      {isLoading ? (
        <div className="w-full flex justify-center items-center py-20">
          <Loader2 className="animate-spin h-10 w-10 text-blue-600" />
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {candidates.map((candidat) => (
            <Card
              onClick={() => viewCandidate(candidat)}
              key={candidat._id}
              className="shadow-lg hover:cursor-pointer min-h-88 max-h-88 hover:shadow-xl transition-shadow duration-300 rounded-lg flex flex-col"
            >
              <CardHeader className="flex-shrink-0">
                <CardTitle className="text-xl text-blue-700">
                  <div className="flex items-center justify-between">
                    <p className="capitalize">
                      {candidat.firstname} {candidat.lastname}
                    </p>
                    <div className="flex-shrink-0">
                      {candidat.image ? (
                        <img
                          src={`data:image/jpeg;base64,${candidat.image}`}
                          alt={`${candidat.firstname} ${candidat.lastname}`}
                          className="w-16 h-16 rounded-full object-cover border-2 border-gray-200"
                        />
                      ) : (
                        <div className="w-16 h-16 uppercase rounded-full bg-gray-200 flex items-center justify-center text-gray-500 text-2xl font-bold">
                          {candidat.firstname ? candidat.firstname.charAt(0) : '?'}
                          {candidat.lastname ? candidat.lastname.charAt(0) : '?'}
                        </div>
                      )}
                    </div>
                  </div>
                </CardTitle>
              </CardHeader>
              <CardContent className="flex-grow">
                <div className="mb-2">
                  <h4 className="text-sm font-semibold text-gray-700 mb-1">
                    Compétences clés:
                  </h4>
                  <div className="flex flex-wrap gap-1">
                    {candidat.qualifications?.slice(0, 3).map((comp, index) => (
                      <span
                        key={index}
                        className="px-2 py-0.5 text-xs bg-blue-100 text-blue-700 rounded-full"
                      >
                        {comp}
                      </span>
                    ))}
                  </div>
                </div>
              </CardContent>
              <CardFooter className="flex-shrink-0 flex justify-between items-center text-sm text-gray-500 pt-4 border-t">
                <span>
                  Statut:{" "}
                  <span
                    className={`font-semibold ${
                      candidat.status === "Disponible"
                        ? "text-green-600"
                        : candidat.status === "En mission"
                          ? "text-orange-500"
                          : "text-purple-600"
                    }`}
                  >
                    {candidat.status}
                  </span>
                </span>
                {candidat.pld && (
                  <span className="italic text-red-600">#{candidat.pld}</span>
                )}
              </CardFooter>
            </Card>
          ))}
        </div>
      )}
    </div>
    </div>
  );
}
